import React from 'react';
// Components
import ManageProductsTable from 'components/common/ManageProductsTable';

const ManageContentCreatorProducts: React.FC = () => {
  return <ManageProductsTable />;
};

export default ManageContentCreatorProducts;
